<template>
  <div>
    <receipt-invoice v-if="isRecipt" :sendCaptureRespos="sendCaptureRespos"></receipt-invoice>
    <v-container fluid v-if="!isRecipt">
      <v-card color="grey lighten-4" rounded="lg" width="800" flat class="mx-auto pa-8 mt-7">
        <v-card-title class="primary--text display-2 font-weight-bold justify-center">Something went Wrong !</v-card-title>
        <v-icon class="d-flex justify-center my-2" size="150" color="orange">mdi-emoticon-sad</v-icon>
        <v-card-subtitle class="d-flex justify-center my-2 title">Please try again, after sometime...</v-card-subtitle>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import ReceiptInvoice from '../../Admission/invoice'
export default {
  name: 'ReciptInvoice',
  components: {
    ReceiptInvoice
  },
  props: ['sendCaptureRespos'],
  data () {
    return {
      isRecipt: false
    }
  },
  methods: {
    printInvoice: async function () {
      this.isRecipt = true
    }
  }
}
</script>
